import { Loan } from './Loan/Loan'
import { CurrentLoan } from '../../../../types/loan'
import { Card, Flex, Text, CardBody } from '@homebotapp/hb-react-component-catalog'

export interface NumberedLoanListProps {
  loans: CurrentLoan[]
}

export const NumberedLoanList = ({ loans }) => {
  return (
    <ol>
      {loans.map((loan: CurrentLoan, index: number) => (
        <li key={loan.id}>
          <Card mb={4} mx={4}>
            <CardBody
              p={0}
              display='flex'
              alignItems='center'
              flexDirection='row'
              borderRadius='0.375rem'
              // @ts-ignore
              backgroundColor='var(--brand-surface-layer-50) !important'
            >
              <Card
                h={9}
                w={9}
                align='center'
                justify='center'
                borderRadius='50%'
                pointerEvents='none'
                transform='translateX(-50%)'
              >
                <Text mb={0} fontWeight='semibold'>
                  {index + 1}
                </Text>
              </Card>
              <Loan loan={loan} />
            </CardBody>
          </Card>
        </li>
      ))}
    </ol>
  )
}
